import React from "react";
import { TypesOfCoverRecord } from "pages/licence-checking/grey-fleet/shared";
import PropTypes from "prop-types";

const defaultArray = [];

// True once the company has recorded the cover it requires for the check and at least one of those
// types still resolves in the lookup. A required type retired from the lookup cannot be named, and
// a dash under the header would read as "this check requires no cover", which is a different thing
// entirely.
export function hasRequiredCoverTypes(insurance, coverTypes = defaultArray) {
    if (
        !Array.isArray(insurance?.requiredCoverTypeIds) ||
        !Array.isArray(coverTypes)
    ) {
        return false;
    }

    return insurance.requiredCoverTypeIds.some((coverTypeId) =>
        coverTypes.some((coverType) => coverType.id === coverTypeId)
    );
}

// The cover the company required on approval beside the cover the driver declared, so the two can
// be compared side by side. Rendered as two sibling records so it drops straight into a grid.
export function GreyFleetCheckCoverRecords({
    isLoading,
    insurance,
    coverTypes = defaultArray,
}) {
    return (
        <>
            <TypesOfCoverRecord
                loading={isLoading}
                header="Required type(s) of cover"
                coverTypeIds={insurance?.requiredCoverTypeIds ?? defaultArray}
                coverTypes={coverTypes}
            />
            <TypesOfCoverRecord
                loading={isLoading}
                header="Declared type(s) of cover"
                coverTypeIds={insurance?.coverTypeIds ?? defaultArray}
                coverTypes={coverTypes}
            />
        </>
    );
}

GreyFleetCheckCoverRecords.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    insurance: PropTypes.object,
    coverTypes: PropTypes.array,
};
